// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.logo-letter img {
  display: inline-block;
  opacity: 0; /* Start hidden */
  animation: fadeIn 2s ease-in-out forwards;
  position: absolute;
}

/* Ensure the special 4th letter (O) fades in more slowly */
.logo-special {
  animation: fadeIn 6s ease-in-out forwards;
}


@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/MenuBar/LogoAnimation.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,UAAU,EAAE,iBAAiB;EAC7B,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA,2DAA2D;AAC3D;EACE,yCAAyC;AAC3C;;;AAGA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF","sourcesContent":[".logo-letter img {\n  display: inline-block;\n  opacity: 0; /* Start hidden */\n  animation: fadeIn 2s ease-in-out forwards;\n  position: absolute;\n}\n\n/* Ensure the special 4th letter (O) fades in more slowly */\n.logo-special {\n  animation: fadeIn 6s ease-in-out forwards;\n}\n\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
